import {Component, QueryList, ViewChildren} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {CONFIG} from "../../../app/config";

import {DataService} from "../../../providers/data-service";
import {ShowviewPage} from "../showview/showview";
import {ShowviewListaPage} from "../showview-lista/showview-lista";

@Component({
    selector: 'page-showview-atracao',
    templateUrl: 'showview-atracao.html',
    providers: []
})

export class ShowviewAtracaoPage {

    config: any;
    logado: any;
    perfil: any;

    @ViewChildren('lgBts') lgBts: QueryList<any>;

    anySelected: any;
    intSelected: any = 0;

    data: any = [
        {

            tipo: "atracao",
            titulo: "Vintage Culture",
            texto: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?",
            fontColor: "black",
            imgLogo: "https://www.lorean.com.br/manager/desktop/images/vintage-escrito.png",
            imgBanda: "https://www.lorean.com.br/manager/desktop/images/vintageculture.png",
            GaleriaFile: "",
            GaleriaColor: "rgba(255,255,255,1)",
            botao: "Entre em contato",
            linkBotao: "",
            preco: "3.200",
            contato: [
                {
                    telefone: "14 3232-5454",
                    celular: "14 2234-5423",
                    email: "contato@vintadeculture.com.br",
                }
            ],
            facebook: "https://m.facebook.com/vintageculturemusic/",
            instagram: "https://www.instagram.com/vintageculture/",
            youtube: "https://www.youtube.com/watch?v=IZTAiXWsCc0",
            twitter: "",
            galeria: [
                {
                    thumb: "https://geo-media.beatport.com/image/12722836.jpg",
                    src: "https://geo-media.beatport.com/image/12722836.jpg",
                }, {
                    thumb: "http://www.agendanatal.com.br/images/eventos/vintage-culture-corona-sunset-x49y214154.jpg",
                    src: "http://www.agendanatal.com.br/images/eventos/vintage-culture-corona-sunset-x49y214154.jpg",
                }, {
                    thumb: "https://cdn.phouse.com.br/wp-content/uploads/2016/01/28135947/vintage-culture1.jpg",
                    src: "https://cdn.phouse.com.br/wp-content/uploads/2016/01/28135947/vintage-culture1.jpg",
                }, {
                    thumb: "https://hashtagcuritiba.com/wp-content/uploads/2016/12/VINTAGE_CULTURE.jpg",
                    src: "https://hashtagcuritiba.com/wp-content/uploads/2016/12/VINTAGE_CULTURE.jpg",
                }, {
                    thumb: "https://cdn.phouse.com.br/wp-content/uploads/2016/11/23065533/Vintage-Culture.jpg",
                    src: "https://cdn.phouse.com.br/wp-content/uploads/2016/11/23065533/Vintage-Culture.jpg",
                }, {
                    thumb: "https://www.agendanatal.com.br/images/eventos/vintage-culture-corona-sunset-x49y214154.jpg",
                    src: "https://www.agendanatal.com.br/images/eventos/vintage-culture-corona-sunset-x49y214154.jpg",
                }, {
                    thumb: "https://cdn.phouse.com.br/wp-content/uploads/2016/01/28135947/vintage-culture1.jpg",
                    src: "https://cdn.phouse.com.br/wp-content/uploads/2016/01/28135947/vintage-culture1.jpg",
                }, {
                    thumb: "https://hashtagcuritiba.com/wp-content/uploads/2016/12/VINTAGE_CULTURE.jpg",
                    src: "https://hashtagcuritiba.com/wp-content/uploads/2016/12/VINTAGE_CULTURE.jpg",
                }, {
                    thumb: "https://cdn.phouse.com.br/wp-content/uploads/2016/11/23065533/Vintage-Culture.jpg",
                    src: "https://cdn.phouse.com.br/wp-content/uploads/2016/11/23065533/Vintage-Culture.jpg",
                }, {
                    thumb: "https://cdn.phouse.com.br/wp-content/uploads/2016/11/23065533/Vintage-Culture.jpg",
                    src: "https://cdn.phouse.com.br/wp-content/uploads/2016/11/23065533/Vintage-Culture.jpg",
                }, {
                    thumb: "https://cdn.phouse.com.br/wp-content/uploads/2016/11/23065533/Vintage-Culture.jpg",
                    src: "https://cdn.phouse.com.br/wp-content/uploads/2016/11/23065533/Vintage-Culture.jpg",
                }, {
                    thumb: "https://www.mag360.com.br/wp-content/uploads/2017/10/alok-vintage-culture-e-cat-dealers-estao-entre-os-melhores-djs-do-mundo.jpeg",
                    src: "https://www.mag360.com.br/wp-content/uploads/2017/10/alok-vintage-culture-e-cat-dealers-estao-entre-os-melhores-djs-do-mundo.jpeg",
                }
            ]
        }, {
            tipo: "atracao",
            titulo: "Steve Aoki",
            texto: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?",
            fontColor: "black",
            imgLogo: "https://storage.lorean.com.br/arquivo/showtime/logo-steve.png",
            imgBanda: "https://storage.lorean.com.br/arquivo/showtime/steve-aoki.png",
            GaleriaFile: "",
            GaleriaColor: "rgba(255,255,255,1)",
            botao: "Entre em contato",
            linkBotao: "",
            preco: "3.200",
            contato: [
                {
                    telefone: "14 3232-5454",
                    celular: "14 2234-5423",
                    email: "contato@vintadeculture.com.br",
                }
            ],
            facebook: "facebook.com.br",
            instagram: "instagram.com.br",
            youtube: "",
            twitter: "twitter.com.br",
            galeria: [
                {

                    thumb: "https://cache.clickcamboriu.com.br/2017/05/steve-aoki.jpg",
                    src: "https://cache.clickcamboriu.com.br/2017/05/steve-aoki.jpg"
                }, {
                    thumb: "https://cdn.worldredeye.com/wp-content/uploads/2016/10/12/53-steve-aoki-performing45-898x599.jpg",
                    src: "https://cdn.worldredeye.com/wp-content/uploads/2016/10/12/53-steve-aoki-performing45-898x599.jpg"
                }, {
                    thumb: "https://img.wennermedia.com/social/rs-126843-20131118-steve-aoki-25-x1800-1384805946.jpg",
                    src: "https://img.wennermedia.com/social/rs-126843-20131118-steve-aoki-25-x1800-1384805946.jpg"
                }, {
                    thumb: "https://img2-ak.lst.fm/i/u/arO/6abededd68b34609c653077e51d21d77",
                    src: "https://img2-ak.lst.fm/i/u/arO/6abededd68b34609c653077e51d21d77"
                }, {
                    thumb: "https://www.duskmusicfestival.com/wp-content/uploads/2017/07/steve-aoki-2-1280x720.jpg",
                    src: "https://www.duskmusicfestival.com/wp-content/uploads/2017/07/steve-aoki-2-1280x720.jpg"
                }, {
                    thumb: "https://www.youredm.com/wp-content/uploads/2017/03/steve-aoki-rukes-best-pic.jpg",
                    src: "https://www.youredm.com/wp-content/uploads/2017/03/steve-aoki-rukes-best-pic.jpg"
                }, {
                    thumb: "https://www.trbimg.com/img-53e28b3c/turbine/la-ca-0810-steve-aoki-002",
                    src: "https://www.trbimg.com/img-53e28b3c/turbine/la-ca-0810-steve-aoki-002"
                }, {
                    thumb: "https://www.edmtunes.com/wp-content/uploads/2017/06/Screen-Shot-2015-09-28-at-10.png",
                    src: "https://www.edmtunes.com/wp-content/uploads/2017/06/Screen-Shot-2015-09-28-at-10.png"
                }, {
                    thumb: "https://www.ucsbalum.com/Coastlines/2014/Winter/Images/Aoki-Packaging_D_084.jpg",
                    src: "https://www.ucsbalum.com/Coastlines/2014/Winter/Images/Aoki-Packaging_D_084.jpg"
                }, {
                    thumb: "https://www.billboard.com/files/styles/article_main_image/public/media/Steve-aoki-2017-cr-Brian-Ziff-billboard-1548.jpg",
                    src: "https://www.billboard.com/files/styles/article_main_image/public/media/Steve-aoki-2017-cr-Brian-Ziff-billboard-1548.jpg"
                }, {
                    thumb: "https://www.much.com/wp-content/uploads/2017/03/Just-Hold-On-Music-Video-981x552.jpg",
                    src: "https://www.much.com/wp-content/uploads/2017/03/Just-Hold-On-Music-Video-981x552.jpg"
                }, {
                    thumb: "https://c.looklive.com/s/Steve-Aoki-Instagram-2017-02-14_L3hhTUliNXdpanZ1RGJtZ1VQUTk5alZBMC02ST0vMTg1eDI2OjU3NXg2MTAvNjQweDAvMTVhMTA4YzEtZDQyMC00YjZiLThlYjEtNzg1NTZmMGU5MDQy",
                    src: "https://c.looklive.com/s/Steve-Aoki-Instagram-2017-02-14_L3hhTUliNXdpanZ1RGJtZ1VQUTk5alZBMC02ST0vMTg1eDI2OjU3NXg2MTAvNjQweDAvMTVhMTA4YzEtZDQyMC00YjZiLThlYjEtNzg1NTZmMGU5MDQy"
                }
            ]
        }
    ];

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public dataService: DataService,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.logado;

        this.anySelected = this.data[this.intSelected];

        //APP-NEW-VERSION - REVISAR

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showview - Atração', '/showview-atracao');

    }

    openNovidade() {
        this.navCtrl.setRoot(ShowviewPage, {}, {animate: true, direction: 'forward'});
    }

    static openUrl(url) {
        let left = (window.screen.width / 2) - ((530 / 2) + 10);
        let top = (window.screen.height / 2) - ((650 / 2) + 50);
        window.open(url, '_system', 'toolbar=no, location=yes, status=no, menubar=no, scrollbars=yes,resizable=yes,left=' + left + ',top=' + top + ',screenX=' + left + ',screenY=' + top + ', width=530, height=650');
    }

    atracaopay(param) {

        console.log(param);

    }

    openListaAtracao() {

        let objectOpts = {
            enableBackdropDismiss: false,
            cssClass: "page-novidade-modal-lista",
            //cssClass:"page-atracao-modal-lista"}
        };

        let objectData = {atracaoData: this.data};
        this.util.modalopen(ShowviewListaPage, 'wide', false, objectData, null, objectOpts).subscribe(
            data => {

                if (data != "") this.anySelected = this.data[data];

            });

    }
/*
    lgOpen(index) {

        let bt = this.lgBts.toArray().find((e) => {
            return e.nativeElement.getAttribute('id') == index;
        }).nativeElement;

        (<any>window).$(bt).lightGallery({share: false, hash: false, dynamic: true, dynamicEl: this.anySelected.galeria, index: index});

    }
*/
}



// WEBPACK FOOTER //
// ./src/pages/show/showview-atracao/showview-atracao.ts